/**
 * 头部导航
 */
export default {
  signIn: '登录',
  signOut: '退出',
}
